import { DataTable } from "primereact/datatable";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomSortIcon } from "../../Bank/report/widget/CustomSortIcon";
import exportimages from "../../../assets/images/exportImages";
import { Dropdown } from "primereact/dropdown";
import "./CustomDataTable.scss";
import searchLogo from "../../../assets/images/Search.png";
import {
  resetCampaignPaginationReducerState,
  setCampaignDataTablePagination,
} from "../../../Redux/paginationSlice";

const CustomDataTable = ({
  filteredData,
  dataTableState,
  setDataTableState,
  searhPlaceholder,
  showPaginator,
  showSearch,
  searchClass,
  showFilter,
  filterOptions,
  rowSelection,
  children,
  filterDropDownType,
  filterPlaceholder,
  PendingInvitationButton,
}) => {
  const { currentPage, limit, totalRecords, sortObj, selectedFilter } =
    dataTableState;
  const loader = useSelector((state) => state?.loaderReducer);
  const dispatch = useDispatch();

  const templateForPaginator = {
    layout:
      "RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
    CurrentPageReport: (options) => {
      let totalPage = Math.ceil(totalRecords / limit);
      return (
        <span className="mr-5">
          {currentPage} of {totalPage}
        </span>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: 40, value: 40 },
        { label: 50, value: 50 },
      ];
      return (
        <div className="d-none d-md-none  d-sm-none d-xs-none  d-lg-flex ">
          <span className="d-flex align-items-center">Per page</span>
          <Dropdown
            style={{ width: "auto" }}
            value={limit}
            options={dropdownOptions}
            onChange={handleDropdownValue}
            placeholder={"10"}
          />
          <span className="d-flex align-items-center">
            Displaying{" "}
            {loader?.loader ? "" : Math.min(currentPage * limit, totalRecords)}{" "}
            of {loader?.loader ? "" : totalRecords}
          </span>
        </div>
      );
    },
    PrevPageLink: (options) => {
      return (
        <div className="" style={{ padding: "0.5rem 1rem" }}>
          <button
            className={` p-paginator-element p-link ${
              currentPage === 1 ? "p-disabled" : ""
            }`}
            onClick={(e) => handlePrevPage(e)}
            disabled={currentPage === 0}
          >
            <span className="p-paginator-icon pi pi-angle-left" />
          </button>
        </div>
      );
    },
    NextPageLink: (options) => {
      return (
        <div className="" style={{ padding: "0.5rem 1rem" }}>
          <button
            className={` p-paginator-element p-link  ${
              currentPage === Math.ceil(totalRecords / limit)
                ? "p-disabled"
                : ""
            }`}
            onClick={(e) => handleNextPage(e)}
          >
            <span className="p-paginator-icon pi pi-angle-right" />
          </button>
        </div>
      );
    },
    FirstPageLink: (options) => {
      return (
        <div className="" style={{ padding: "0.5rem 1rem" }}>
          <button
            className={` p-paginator-element p-link ${
              currentPage === 1 ? "p-disabled" : ""
            }`}
            onClick={(e) => handleFirstPage(e)}
            disabled={currentPage === 1}
          >
            <span className="p-paginator-icon pi pi-angle-double-left" />
          </button>
        </div>
      );
    },
    LastPageLink: (options) => {
      return (
        <div className="" style={{ padding: "0.5rem 1rem" }}>
          <button
            className={` p-paginator-element p-link ${
              currentPage === Math.ceil(totalRecords / limit)
                ? "p-disabled"
                : ""
            }`}
            onClick={(e) => handleLastPage(e)}
            disabled={currentPage === Math.ceil(totalRecords / limit)}
          >
            <span className="p-paginator-icon pi pi-angle-double-right" />
          </button>
        </div>
      );
    },
    PageLinks: (options) => {
      if (options.totalPages === 1) {
        const pages = [];
        const maxPagesToShow = 3;

        let startPage = Math.max(
          1,
          currentPage - Math.floor(maxPagesToShow / 2),
        );
        let endPage = Math.min(
          Math.ceil(totalRecords / limit),
          startPage + maxPagesToShow - 1,
        );

        // Adjust startPage to ensure exactly maxPagesToShow links are shown
        if (endPage - startPage + 1 < maxPagesToShow) {
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }
        startPage = Math.max(1, startPage);
        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <button
              key={i}
              className={`p-paginator-element p-link p-paginator-page ${
                currentPage === i ? "p-highlight" : ""
              }`}
              onClick={(e) => handlePageChangeNew(e, { page: i })}
            >
              {i}
            </button>,
          );
        }
        return <div className="p-paginator-pages">{pages && pages}</div>;
      }
    },
  };
  const handleDropdownValue = (value) => {
    setDataTableState((prevState) => ({
      ...prevState,
      currentPage: 1,
      limit: value?.value,
    }));
  };
  const handleLastPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let lastPage = Math.ceil(totalRecords / limit);
    if (lastPage > 0) {
      dispatch(setCampaignDataTablePagination(lastPage));
      setDataTableState((prevState) => ({
        ...prevState,
        currentPage: lastPage,
      }));
    }
  };
  const handleFirstPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setCampaignDataTablePagination(1));
    setDataTableState((prevState) => ({
      ...prevState,
      currentPage: 1,
    }));
  };
  const handlePrevPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentPage > 0) {
      dispatch(setCampaignDataTablePagination(currentPage - 1));
      setDataTableState((prevState) => ({
        ...prevState,
        currentPage: currentPage - 1,
      }));
    }
  };
  const handleNextPage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentPage < Math.ceil(totalRecords / limit)) {
      dispatch(setCampaignDataTablePagination(currentPage + 1));
      setDataTableState((prevState) => ({
        ...prevState,
        currentPage: currentPage + 1,
      }));
    }
  };
  const handlePageChangeNew = (e, { page }) => {
    e.preventDefault();
    e.stopPropagation();
    if (page !== currentPage) {
      dispatch(setCampaignDataTablePagination(page));
      setDataTableState((prevState) => ({
        ...prevState,
        currentPage: page,
      }));
    }
  };
  const onSort = (field) => {
    let sortValue = field?.sortOrder === 1 ? "ASC" : "DESC";
    setDataTableState((prevState) => ({
      ...prevState,
      sortObj: {
        sortField: field?.sortField,
        sortOrder: sortValue,
        sortOrderValue: field?.sortOrder,
        sortOrderV1: "modified_on",
      },
    }));
  };
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);
    };
  };
  const handleSearchData = (value) => {
    setDataTableState((prevState) => ({
      ...prevState,
      searchData: value,
      currentPage: 1,
    }));
  };
  const optimizedSearchData = useCallback(debounce(handleSearchData), [
    limit,
    sortObj,
    dataTableState?.searchData,
  ]);
  const groupedItemTemplate = (option) => {
    return (
      <div
        className={
          filterDropDownType === "group" ? "flex align-items-center" : "d-none"
        }
        style={{
          borderTop:
            option?.optionGroup?.label === "Campaign Type"
              ? "1px solid #F0F0F0"
              : "0px",
          padding: "0.615rem 1.231rem",
          fontSize: "1.077rem",
        }}
      >
        <div>{option.label}</div>
      </div>
    );
  };

  const HeaderForTable = () => {
    return (
      <div className="row align-items-stretch">
        {showSearch && (
          <div className="col-xl-4">
            <div
              className={`search-field w-100 w-sm-100 w-xs-100 position-relative ${searchClass ? searchClass : ""}`}
            >
              <div className="static-img ">
                <img src={searchLogo} alt="icon" className="searchicon" />
              </div>
              <input
                type="text"
                className="form-control custom-input-field"
                onChange={(e) => {
                  optimizedSearchData(e?.target?.value);
                }}
                placeholder={`${searhPlaceholder}`}
                disabled={loader?.loader}
              />
            </div>
          </div>
        )}

        {showFilter && filterDropDownType === "group" && (
          <div className="col-xl-3 ms-5 custom-dropdown">
            <Dropdown
              value={selectedFilter}
              onChange={(e) => {
                dispatch(resetCampaignPaginationReducerState(null));
                setDataTableState((prevState) => ({
                  ...prevState,
                  selectedFilter: e.value,
                  currentPage: 1,
                }));
              }}
              options={filterOptions}
              optionLabel="label"
              optionGroupLabel="label"
              optionGroupChildren="items"
              optionGroupTemplate={groupedItemTemplate}
              className="listFilterDropdown filterCampaign"
              panelClassName="custom-group-dropdown"
              placeholder="Filter"
            />
            <img
              src={exportimages?.Filter}
              alt="err"
              className="custom-dropdown-icon ms-3 filtericon text-muted"
            />
          </div>
        )}

        <div className="col-xl-8 row d-flex flex-row-reverse pe-6">
          {showFilter && filterDropDownType === "single" && (
            <div className="col-xl-3 custom-dropdown">
              <Dropdown
                value={selectedFilter}
                onChange={(e) => {
                  dispatch(resetCampaignPaginationReducerState(null));

                  setDataTableState((prevState) => ({
                    ...prevState,
                    selectedFilter: e.value,
                    currentPage: 1,
                  }));
                }}
                options={
                  filterOptions
                    ? [...filterOptions]
                    : [{ name: "All", code: "" }]
                }
                optionLabel="name"
                placeholder={filterPlaceholder ? filterPlaceholder : "Filter"}
                className="listFilterDropdown filterCampaign"
                style={{ fontSize: "1.2rem" }}
              />
              <img
                src={exportimages?.Filter}
                alt="err"
                className="custom-dropdown-icon ms-3 filtericon text-muted"
              />
            </div>
          )}

          {PendingInvitationButton != null && (
            <div className="col-xl-3 custom-dropdown">
              <PendingInvitationButton />
            </div>
          )}
        </div>
      </div>
    );
  };
  return (
    <DataTable
      value={filteredData}
      className="custom-datatable p-custom-datatable"
      selectionMode={rowSelection ? "single" : ""}
      rows={filteredData?.length}
      paginator={showPaginator === true && filteredData?.length > 0 && "true"}
      paginatorTemplate={templateForPaginator}
      reflow="true"
      sortField={sortObj?.sortField}
      sortOrder={!loader?.loader && sortObj?.sortOrderValue}
      onSort={onSort}
      header={HeaderForTable}
      rowHover="true"
      scrollable="true"
      scrollHeight="flex"
      resizableColumns="true"
      sortIcon={CustomSortIcon}
      emptyMessage={() => (
        <h5 className="text-center pt-4 mt-1 mb-0 w-100">
          <div className="col-md-12 mb-8">
            <img src={exportimages.noDataFound} alt="no data" />
          </div>
          <div className="col-md-12">
            <h5>There is no data to display at the moment.</h5>
          </div>
        </h5>
      )}
    >
      {children}
    </DataTable>
  );
};

export default CustomDataTable;
